<template>
  <div
    v-show="order.total < 0"
    class="q-mt-sm q-mx-xs"
  >
    <div class="row items-center">
      <h2
        v-if="credits.length"
        class="col"
      >
        {{ $tc('pricing.creditUnit', 2) }}
      </h2>
    </div>

    <q-list
      v-if="credits.length"
      bordered
      separator
    >
      <q-slide-item
        v-for="payment in credits"
        :key="payment.id"
        right-color="negative"
        class="bg-responsive"
        @right="order.payments.remove(payment)"
      >
        <template
          v-if="payment.state === PAYMENT_STATES.DRAFT"
          #right
        >
          <q-icon
            left
            name="delete"
          />
          {{ $t('actions.remove') }}
        </template>
        <q-item
          class="row"
          :class="payment.state === PAYMENT_STATES.DRAFT ? 'bg-responsive' : 'bg-responsive-grey-4'"
        >
          <q-item-section class="col-grow">
            <q-item-label
              overline
              class="text-uppercase"
            >
              {{ payment.type === PAYMENT_TYPES.CARD ? ((payment.cardType || '') + ' ...' + (payment.lastFour || '')) : payment.type }}
            </q-item-label>
          </q-item-section>
          <q-item-section class="text-right">
            <i18n-n
              :value="-payment.amount"
              format="currency"
              scope="global"
            />
          </q-item-section>
          <q-item-section
            v-if="payment.state === 'completed'"
            class="col-auto"
          >
            <q-icon
              name="lock"
              color="grey"
            />
          </q-item-section>
          <q-item-section
            v-if="payment.state === 'canceled'"
            class="col-auto"
          >
            <q-icon
              name="error"
              color="grey"
            />
          </q-item-section>
        </q-item>
      </q-slide-item>
    </q-list>
  </div>
</template>

<script>
import { PAYMENT_STATES, PAYMENT_TYPES } from 'src/models/payment/Payment'
export default {
  name: 'NegativePaymentSliders',
  props: {
    order: {
      type: Object,
      required: true
    },
    credits: {
      type: Array,
      required: true
    }
  },
  emits: ['edit-payment'],
  created () {
    _.extend(this, {
      PAYMENT_STATES,
      PAYMENT_TYPES
    })
  },
  methods: {
    editPayment (payment) {
      this.$emit('edit-payment', payment)
    }
  }
}
</script>
